const eventTemplate = {
    firstTeamName: "First team name",
    secondTeamName: "Second team name",
    eventTime: "",
    eventDate: "",
    bookies: []
}


export default eventTemplate;